import { Spin, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import DuesTab from "../../components/AccountDetails/DuesTab";
import ClapIncomes from "../../components/_shared/ClapIncomes";
import ClapInvoices from "../../components/_shared/ClapInvoices";
import ClapPayments from "../../components/_shared/ClapPayments";
import ClientProfile from "../../components/_shared/ClientProfile";
import {
  getSingleClient,
  resetClient,
} from "../../redux/actions/accountActions";
import { RootState } from "../../redux/rootReducer";

const { TabPane } = Tabs;

function AccountDetails() {
  const dispatch = useDispatch();
  const location = useLocation();
  const clientRecord = location.state;
  const [effect, setEffect] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [clientDetails, setClientDetails] = useState<any>(null);
  const { clientId } = useParams();
  const { client } = useSelector((state: RootState) => state.account);
  const { createInvoiceSuccess } = useSelector(
    (state: RootState) => state.invoice,
  );

  useEffect(() => {
    if (clientRecord) setClientDetails(clientRecord);
    else if (client) setClientDetails(client);
  }, [client]);

  useEffect(() => {
    if (clientId) {
      dispatch(resetClient());
      if (!clientRecord) dispatch(getSingleClient(clientId));
    }
  }, [effect]);

  const onTabChange = (activeKey: string) => {
    setActiveTabKey(activeKey);
  };

  useEffect(() => {
    if (createInvoiceSuccess) {
      setActiveTabKey("2");
      setEffect(!effect);
    }
  }, [createInvoiceSuccess]);

  return (
    <div>
      <div className="flex flex-wrap gap-6 mb-12">
        <ClientProfile client={clientDetails} />
        <div className="col-span-2 flex">
          <div className="default-border py-[7px] px-[14px] min-w-[380px]">
            <div className="text-subheading16 mb-[10px]">Revenue (Approx)</div>
            <div className="flex gap-x-8">
              <div>
                <div>USD</div>
                <div className="text-heading21 text-danger">
                  {clientDetails?.total_usd_due || 0}
                </div>
              </div>
              <div>
                <div>EUR</div>
                <div className="text-heading21 text-danger">
                  {clientDetails?.total_euro_due || 0}
                </div>
              </div>
              <div>
                <div>BDT</div>
                <div className="text-heading21 text-danger">
                  {clientDetails?.total_bdt_due || 0}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div /> */}
        {/* <div className="flex gap-2">
          <Button>Edit Account</Button>
          <Button className="flex items-center">
            {icons.DotsHorizontal("w-4")}
          </Button>
        </div> */}
      </div>
      <div>
        <Tabs
          activeKey={activeTabKey}
          tabBarStyle={{ marginBottom: "23px" }}
          destroyInactiveTabPane
          onChange={onTabChange}
        >
          <TabPane tab="Incomes" key="1">
            {clientDetails ? (
              <ClapIncomes isClientDetails clientDetails={clientDetails} />
            ) : (
              <div className="text-center pt-2">
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 34 }} />}
                />
              </div>
            )}
          </TabPane>
          <TabPane tab="Invoices" key="2">
            <ClapInvoices isClientDetails />
          </TabPane>
          <TabPane tab="Payments" key="3">
            <ClapPayments isClientDetails />
          </TabPane>
          <TabPane tab="Dues" key="4">
            <DuesTab />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
}

export default AccountDetails;
